/** @jsxImportSource @emotion/react */
import React from 'react'
import { COLORS } from '@btime/constants'
import { css } from '@emotion/react'
import Markdown from 'react-markdown'

import fontSizes from '../../utils/constants/fontSizes'
import { usePdfOptionsForm } from './options/_form/PdfOptionsFormHandler'

const MarkdownPresentation = ({ children, value, fontFamily, noMargin, align }) => {
  const { fontBase, hasColors, showImages, imagesHeight } = usePdfOptionsForm()
  const fontSize = fontSizes['p']

  const style = css`
    font-family: ${fontFamily || `'SF Pro Display', 'Nunito', sans-serif !important`};
    line-height: 1.7;
    color: ${!hasColors ? COLORS.black + '40' : COLORS.dark3};
    white-space: pre-line;

    & p {
      margin: 0;
      margin-bottom: ${noMargin ? 0 : '0.75rem'};
      text-align: ${align || 'left'};
      font-size: ${fontSize * fontBase}px;
    }

    & hr {
      border: solid 1px ${COLORS.light3};
    }

    & a,
    & a:visited {
      color: ${!hasColors ? COLORS.black + '40' : COLORS.purple};
      font-weight: 400;
      text-decoration: none;
    }

    & img {
      max-width: 100%;
      height: ${imagesHeight === 0 ? 'auto' : imagesHeight};
      display: ${!showImages ? 'none' : 'block'};
    }

    & ul,
    & ol {
      margin: 0;
      padding-left: 1rem;
      font-size: ${fontSize * fontBase}px;
    }
  `

  const renderers = {
    paragraph: ({ children }) => (
      <p
        style={{
          fontFamily: fontFamily || `'SF Pro Display', 'Nunito', sans-serif !important`,
          lineHeight: 1.7,
          color: !hasColors ? COLORS.black : COLORS.dark3,
          whiteSpace: 'pre-line',
          margin: 0,
          marginBottom: noMargin ? 0 : '0.75rem',
          textAlign: align || 'left',
          fontSize: fontSize * fontBase + 'px'
        }}
      >
        {children}
      </p>
    )
  }

  return (
    <div css={style} className="markdown">
      <Markdown source={children || value} linkTarget="_blank" renderers={renderers} />
    </div>
  )
}

export default MarkdownPresentation
